import React, { useEffect } from 'react';
import ProfileImage from "../../../../../../assets/images/user.png";
import BellIcon from "../../../../../../assets/icons/bellicon.png";
import SettingIcon from "../../../../../../assets/icons/settingicon.png";
import User1 from '../../../../../../images/home-landing-page/user1.png';
import NotifyBlueIcon from '../../../../../../images/home-landing-page/notification-blue-icon.png';
import SettingBlueIcon from '../../../../../../images/home-landing-page/setting-blue-icon.png';
import EmptyProfileImage from '../../../../../../images/navbar/empty-profile-image.png';
import { ArrowLeft, User } from 'lucide-react';

function Index({ activeConversation, setNotification, notification, onBack, onShowProfile })
{
    useEffect(() =>
    {

        if (notification)
        {
            const timer = setTimeout(() =>
            {
                setNotification(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [notification, setNotification]);

    return (
        <div class="chat-header">
            <button className="back-button" onClick={onBack}>
                <ArrowLeft size={24} />
            </button>
            <div class="user-image-name" onClick={onShowProfile} style={{ cursor: 'pointer' }}>
                <figure>
                    <img
                        src={activeConversation?.userProfileUrl == null ? EmptyProfileImage : activeConversation?.userProfileUrl}
                        alt="Profile"
                    />
                </figure>
                {activeConversation?.userName} ({activeConversation?.businessName})

            </div>
            <button className="profile-toggle-btn" onClick={onShowProfile} title="View Profile">
                <User size={20} />
            </button>
            <div class="chat-actions">
                <a href="">
                    <img src={NotifyBlueIcon} alt="Notifications" />
                </a>
                <a href="">
                    <img src={SettingBlueIcon} alt="Settings" />
                </a>
            </div>
        </div>

    )
}

export default Index
